const loadPage = (url: string) => window.location.assign(url);

export default loadPage;
